import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAnalytics } from '../../context/AnalyticsContext'
import { getOnboarding } from './onboardingStorage'
import './onboarding.css'

// Изображения из public: Women.png, Men.png, Both.png — по выбору "Who would you like to meet?"
const TEASER_IMAGES = {
  women: '/Women.png',
  men: '/Men.png',
  both: '/Both.png'
}
const TEASER_IMAGE_FALLBACK = '/Both.png'

const OnboardingTeaser = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { trackEvent } = useAnalytics()
  const lookingFor = getOnboarding()?.lookingFor || 'both'
  const teaserSrc = TEASER_IMAGES[lookingFor] || TEASER_IMAGE_FALLBACK

  const onContinue = () => {
    trackEvent('funnel_teaser_completed', { step: 7 })
    navigate('/onboarding/photos')
  }

  return (
    <div className="onboarding-page">
      <div className="onboarding-content">
        <img
          className="square-hero"
          src={teaserSrc}
          alt=""
          onError={(e) => { e.target.onerror = null; e.target.src = TEASER_IMAGE_FALLBACK }}
        />
        <h1 className="h1">{t('onboarding.teaserMatchesWaiting')}</h1>
        <p className="p">
          {t('onboarding.teaserSubtitle')}
        </p>
      </div>

      <button className="cta-fixed" onClick={onContinue}>
        {t('common.continue')}
      </button>
    </div>
  )
}

export default OnboardingTeaser

